import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import Form from "theme/components/atoms/Form/Form";
import Icon from "theme/components/atoms/Icon";
import Select from "theme/components/atoms/Form/Input/Select";
import LabelledIcon from "theme/components/molecules/LabelledIcon";
import Button from "theme/components/atoms/Button";
import EnhanceSorting from "./EnhanceSorting";
import MediaQuery from "theme/components/helpers/MediaQuery";

const Sorting = (props) => (
  <Form onChange={props.sortAction}>
    <div className="category-sorting">
      <Select
        disableValidation
        light
        icon={<Icon icon="chevron-down" size="tiny" title="select store" />}
        iconOpen={<Icon icon="chevron-up" size="tiny" title="select store" />}
        name="sort"
        id="sort"
        value={props.currentValue}
        placeholder={
          <FormattedMessage
            id="components.molecules.Sorting.desktopLabel"
            defaultMessage="Sort by"
          />
        }
        options={props.options}
      />
      <MediaQuery maxWidth={1500 - 1}>
        <Button appearance="ghost" onClick={() => props.toggleFilters()}>
          <LabelledIcon icon="plus" size="tiny" inverted>
            <FormattedMessage
              id="theme.molecules.Sorting.filter"
              defaultMessage="Filter"
            />
          </LabelledIcon>
        </Button>
      </MediaQuery>
    </div>
  </Form>
);

Sorting.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  toggleSorting: PropTypes.func,
  sortAction: PropTypes.func,
  sortingIsVisible: PropTypes.bool,
};

export default EnhanceSorting()(Sorting);
